(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kg-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__kgVTInit) return;
    window.__kgVTInit = true;

    // Auto-stop a playing video once it is scrolled mostly out of view
    // (fixes mobile: swipe to next slide -> previous keeps playing audio off-screen).
    var io = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.target.dataset.loaded && en.intersectionRatio < 0.5) stopVideo(en.target);
          });
        }, { threshold: [0, 0.5, 1] })
      : null;

    function loadVideo(media) {
      if (media.dataset.loaded) return;
      var id = media.getAttribute('data-vt-id');
      if (!id) return;

      // Only one video plays at a time — stop any other that is playing.
      var playing = document.querySelectorAll('[data-kg-vt-yt].is-playing');
      for (var i = 0; i < playing.length; i++) {
        if (playing[i] !== media) stopVideo(playing[i]);
      }

      media.dataset.loaded = '1';
      media.classList.add('is-playing');

      var f = document.createElement('iframe');
      f.className = 'kg-vt__iframe';
      f.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1&controls=1';
      f.title = 'YouTube video';
      f.loading = 'lazy';
      f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      f.setAttribute('allowfullscreen', '');

      var close = document.createElement('button');
      close.type = 'button';
      close.className = 'kg-vt__close';
      close.setAttribute('data-kg-vt-close', '');
      close.setAttribute('aria-label', 'Stop video');
      close.innerHTML = '&times;';

      media.appendChild(f);
      media.appendChild(close);

      if (io) io.observe(media);
    }

    function stopVideo(media) {
      if (io) io.unobserve(media);
      var f = media.querySelector('iframe');
      if (f) f.remove();
      var c = media.querySelector('[data-kg-vt-close]');
      if (c) c.remove();
      media.classList.remove('is-playing');
      delete media.dataset.loaded;
    }

    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;

      var close = e.target.closest('[data-kg-vt-close]');
      if (close) {
        var owner = close.closest('[data-kg-vt-yt]');
        if (owner) { e.preventDefault(); e.stopPropagation(); stopVideo(owner); }
        return;
      }

      var arrow = e.target.closest('[data-kg-vt-arrow]');
      if (arrow) {
        var section = arrow.closest('[data-kg-vt]');
        var track = section && section.querySelector('[data-kg-vt-track]');
        if (track) {
          var slide = track.querySelector('.kg-vt__slide');
          var step = slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
          track.scrollBy({ left: arrow.getAttribute('data-kg-vt-arrow') === 'next' ? step : -step, behavior: 'smooth' });
        }
        return;
      }

      var media = e.target.closest('[data-kg-vt-yt]');
      if (media && !media.dataset.loaded) loadVideo(media);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (!(e.target instanceof Element)) return;
      if (e.target.matches('[data-kg-vt-yt]') && !e.target.dataset.loaded) {
        e.preventDefault();
        loadVideo(e.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
